import React, { useEffect, useRef } from "react";
import Print from "@arcgis/core/widgets/Print";
import "./Export.css";
import { useAuth } from "../../../Providers/AuthProvider/AuthProvider";
import config from "../../Common/config";
import { useTheme } from "../../Layout/ThemeContext/ThemeContext"; // Import the theme context

const PrintComponent = ({ mapview }) => {
  const exportRef = useRef(null);
  const { setexportWidget } = useAuth();
  const { isLangArab } = useTheme(); // Access isDarkMode from ThemeContext


  useEffect(() => {
    const applyStyles = () => {
      const calciteButtons = document.querySelectorAll('calcite-button[kind="brand"]');
  
      calciteButtons.forEach((calciteButton) => {
        if (calciteButton.shadowRoot) {
          const interactionContainer = calciteButton.shadowRoot.querySelector('.interaction-container');
          if (interactionContainer) {
            // Check if the stylesheet has already been applied to avoid duplication
            if (!calciteButton.shadowRoot.adoptedStyleSheets.some(sheet => sheet.ownerNode?.id === 'custom-styles')) {
              // Create a constructed stylesheet
              const styleSheet = new CSSStyleSheet();
              styleSheet.replaceSync(`
                .interaction-container button {
                  background: linear-gradient(
                    270.18deg,
                    #036068 -14.27%,
                    #596451 47.55%,
                    #1E7C87 76.37%,
                    #4C7950 107.69%,
                    #1199A8 147.31%
                  ) !important;
                  color: var(--calcite-color-text-inverse) !important;
                  border-radius: 10px !important;
                }
              `);
  
              // Apply the constructed stylesheet to the shadowRoot
              calciteButton.shadowRoot.adoptedStyleSheets = [
                ...calciteButton.shadowRoot.adoptedStyleSheets,
                styleSheet,
              ];
            }
          }
        }
      });
    };
  
    // MutationObserver to detect when new elements are added to the DOM
    const observer = new MutationObserver((mutations) => {
      applyStyles();
    });
  
    // Start observing the body for any child additions
    const bodyNode = document.querySelector('body');
    if (bodyNode) {
      observer.observe(bodyNode, { childList: true, subtree: true });
    }
  
    // Retry mechanism with timeout to give elements more time to load
    const intervalId = setInterval(() => {
      applyStyles();
    }, 100);
  
    // Stop retrying after 5 seconds
    setTimeout(() => {
      clearInterval(intervalId);
    }, 5000);
  
    // Apply styles initially in case elements already exist
    applyStyles();
  
    // Cleanup on unmount
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    let timeout;

    const applyCustomStyles = () => {
      const layoutTab = document.querySelector("#exportDiv__layoutTab");
      if (layoutTab) layoutTab.textContent = "Export";

      const combobox = document.querySelector("calcite-combobox");
      const comboboxItem = document.querySelector("calcite-combobox-item");

      if (combobox?.shadowRoot) {
        const wrapper = combobox.shadowRoot.querySelector(".wrapper");
        const wrapperActive = combobox.shadowRoot.querySelector(".wrapper--active");

        if (wrapper) {
          wrapper.style.borderColor = "white";
          wrapper.style.height = "40px";
          wrapper.style.borderRadius = "12px";
        }

        if (wrapperActive) {
          wrapperActive.style.outline = "none";
        }
      }

      if (comboboxItem?.shadowRoot) {
        const labelActive = comboboxItem.shadowRoot.querySelector(".label--active");
        if (labelActive) {
          labelActive.style.outline = "none";
        }
      }
    };

    const observer = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        applyCustomStyles();
      }, 100); // Debounce to avoid excessive triggers
    });

    const bodyNode = document.querySelector("body");
    if (bodyNode) {
      observer.observe(bodyNode, { childList: true, subtree: true });
    }

    // Clean up on unmount
    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, []);

  // useEffect(() => {
  //   const buttonObserver = new MutationObserver(() => {
  //     const layoutTab = document.querySelector("#exportDiv__layoutTab");
  //     if (layoutTab) layoutTab.textContent = "Export";

  //     const calciteCombobox = document.querySelector("calcite-combobox");
  //     const WrapperShadow =calciteCombobox?.shadowRoot?.querySelector(".wrapper");
  //     const WrapperShadowActive =calciteCombobox?.shadowRoot?.querySelector(".wrapper--active");
  //     const List = document.querySelector("calcite-combobox-item");
  //     const List_Active = List?.shadowRoot?.querySelector(".label--active");

  //     if (WrapperShadow && WrapperShadowActive && List_Active) {
  //       WrapperShadow.style.borderColor = "white";
  //       WrapperShadow.style.height = "40px";
  //       WrapperShadow.style.borderRadius = "12px";
  //       WrapperShadowActive.style.outline = "none";

  //       List_Active.style.outline = "none";
  //     }
      

      

  //     // const exportsTab = document.querySelector("#exportDiv__exportedFilesTab");
  //     // if (exportsTab) exportsTab.textContent = "Result";
  //   });

  //   const bodyNode = document.querySelector("body");
  //   if (bodyNode) {
  //     buttonObserver.observe(bodyNode, { childList: true, subtree: true });
  //   }

  //   // Cleanup observer on unmount
  //   return () => buttonObserver.disconnect();
  // }, []);

  useEffect(() => {
    if (mapview && exportRef.current) {
      try {
        let PrintServiceURL=null;
        if(isLangArab){
          PrintServiceURL = config.Export.printServiceUrlAr;
        }
        else{
          PrintServiceURL = config.Export.printServiceUrlEng;
        }
        const exportWidget = new Print({
          view: mapview,
          container: exportRef.current,
          printServiceUrl: PrintServiceURL,
          allowedFormats: config.Export.allowedFormats,
          allowedLayouts: config.Export.allowedLayouts,
          templateOptions: {
            title: "My Print",
            //author: "Sam",
            //copyright: "My Company",
            //legendEnabled: false
          },
        });
        setexportWidget(exportWidget);

        // Observe for changes in the exportRef container to remove the "Map Only" tab when it appears
        const observer = new MutationObserver(() => {
          const liElement = document.getElementById("exportDiv__mapOnlyTab");
          if (liElement) {
            liElement.remove(); // Remove the <li> element directly
            observer.disconnect(); // Stop observing once the element is removed
          }
        });

        observer.observe(exportRef.current, { childList: true, subtree: true });

        return () => {
          if (exportRef.current) {
            //printWidget.destroy();
            exportRef.current = null;
          }
        };
      } catch (error) {
        console.error("Error initializing print widget:", error);
      }
    }
  }, [mapview]);

 


  return <div 
  className="  h-[350px] pb-4 mobile_m_360:pb-0 mobile_m_360:h-auto overflow-auto "
  // className=" sm:-mt-[500px] tab:-mt-[100%] h-[400px] laptop_s:h-[353px] overflow-auto   laptop_s:-mt-[365px] laptop_m:-mt-[400px] laptop_lg:-mt-[130%] laptop_lg_2:-mt-[120%] -mt-[420px]"
   id="exportDiv" ref={exportRef} />;

};

export default PrintComponent;
